import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { HoverButton } from "../assets/HoverButton";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

function Navigation() {
  const [pages, setPages] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);


  const location = useLocation();


  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/navigation/`)
      .then((response) => {
        setPages(response.data);
      })
      .catch((error) => console.error("Error fetching navigation data:", error));
  }, []);


  useEffect(() => {
    const contactLinks = document.querySelectorAll(".btn-default.contact");
    contactLinks.forEach((link) => {
      new HoverButton(link);
    });
  }, []);


  const toggleMobileMenu = () => {
    if (mobileOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setMobileOpen(false);
        setIsClosing(false);
      }, 500);
    } else {
      setMobileOpen(true);
    }
  };

  const handleLogoClick = () => {
    if (mobileOpen) {
      toggleMobileMenu();
    }
  };

  useEffect(() => {
    const htmlEl = document.querySelector("html");
    if (mobileOpen) {
      htmlEl.classList.add("menu-open");
    } else {
      htmlEl.classList.remove("menu-open");
    }
  }, [mobileOpen]);

  return (
    <nav className={`d-flex justify-content-between align-items-center ${location.pathname === "/" ? "is-home" : ""}`}>
      <Link
        to="/"
        className="company-logo"
        onClick={handleLogoClick}
      >
        <svg width="85" height="32" viewBox="0 0 85 32" fill="none"> <path d="M66.8028 5.18044C66.8028 7.34213 65.0432 9.09732 62.876 9.09732C60.7089 9.09732 58.9492 7.34213 58.9492 5.18044C58.9492 3.01874 60.7089 1.26355 62.876 1.26355C65.0432 1.26355 66.8028 3.01874 66.8028 5.18044Z" fill="#ffffff" /><path d="M16.0073 11.4639V15.3367L14.7879 13.717C13.4516 11.9334 11.5277 11.0259 9.09198 11.0259C4.0816 11.0259 0 15.7463 0 21.535C0 27.3237 4.0816 32 9.09198 32C11.5308 32 13.4516 31.0987 14.7879 29.3152L16.0073 27.6955V31.5683H21.678V11.467H16.0073V11.4639ZM10.7537 26.6934C7.82833 26.6934 5.45266 24.3773 5.45266 21.5318C5.45266 18.6863 7.82833 16.3702 10.7537 16.3702C13.679 16.3702 16.0073 18.6391 16.0073 21.5318C16.0073 24.4246 13.6506 26.6934 10.7537 26.6934Z" fill="#ffffff" /><path d="M31.3178 0H25.6914V31.5651H31.3178V0Z" fill="#ffffff" /><path d="M50.1027 0V15.3367L48.8833 13.717C47.5375 11.9334 45.6231 11.0259 43.1874 11.0259C38.1675 11.0259 34.0859 15.7463 34.0859 21.535C34.0859 27.3237 38.1675 32 43.1874 32C45.6262 32 47.5407 31.0987 48.8833 29.3152L50.1027 27.6955V31.5683H55.7734V0H50.1027ZM44.8396 26.6934C41.9237 26.6934 39.5386 24.3773 39.5386 21.5318C39.5386 18.6863 41.9237 16.3702 44.8396 16.3702C47.7555 16.3702 50.1027 18.6391 50.1027 21.5318C50.1027 24.4246 47.7366 26.6934 44.8396 26.6934Z" fill="#ffffff" /><path d="M65.6889 11.464H60.0625V31.5652H65.6889V11.464Z" fill="#ffffff" /><path d="M85.0004 15.0119C85.0004 17.1735 83.2407 18.9287 81.0736 18.9287C78.9064 18.9287 77.1562 17.1735 77.1562 15.0119C77.1562 12.8502 78.9159 11.095 81.0736 11.095C83.2313 11.095 85.0004 12.8502 85.0004 15.0119Z" fill="#ffffff" /><path d="M75.603 11.4639H69.9766V31.5651H75.603V11.4639Z" fill="#ffffff" /></svg>
      </Link>
      <ul className="list-group list-group-horizontal d-none d-xl-flex">
        {pages.map((page, index) => {
          const isActive = location.pathname === `/${page.slug}`;
          return (
            <li
              key={page.id}
              className={`list-group-item border-0 ${isActive ? "active" : ""}`}
              style={{ "--i": index }}
            >
              <Link
                to={`/${page.slug}`}
              >
                {page.title}
              </Link>
            </li>
          );
        })}

        <li className="list-group-item border-0" key="external">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://aldir.coredata.is/"
          >
            Fjárfestar
          </a>
        </li>
      </ul>
      <button
        className="mobile-button p-0 d-block d-xl-none font-suisse border-0"
        onClick={toggleMobileMenu}
      >
        {mobileOpen ? "Loka" : "Valmynd"}
      </button>
      {(mobileOpen || isClosing) && (
        <div className={`mobile-menu ${isClosing ? "closing" : ""}`}>
          <div className="bubble"></div>
          <ul className="list-group">
            {pages.map((page, index) => {
              const isActive = location.pathname === `/${page.slug}`;
              return (
                <li
                  key={page.id}
                  className={`list-group-item border-0 mobile-menu-item ${isActive ? "active" : ""
                    }`}
                  style={{ "--i": index }}
                >
                  <Link
                    to={`/${page.slug}`}
                    onClick={toggleMobileMenu}
                  >
                    {page.title}
                  </Link>
                </li>
              );
            })}
            <li className="list-group-item border-0" key="external">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="http://aldir.coredata.is/"
              >
                Fjárfestar
              </a>
            </li>
            <li
              style={{ "--i": pages.length }}
              className={`list-group-item border-0 mobile-menu-item ${location.pathname === "/hafdu-samband" ? "active" : ""
                }`}
            >
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navigation;
